export const SAVE_MERGE_DEFAULTS = "SAVE_MERGE_DEFAULTS"
export const OPEN_MERGE_DRAWER = "OPEN_MERGE_DRAWER"
export const CLOSE_MERGE_DRAWER = "CLOSE_MERGE_DRAWER"
export const CONFIRMING_MERGE_SEND = "CONFIRMING_MERGE_SEND"
export const DISABLE_MERGE_CONFIRMING = "DISABLE_MERGE_CONFIRMING"

export const confirmingMergeSend = () => ({
  type: CONFIRMING_MERGE_SEND,
})

export const disableMergeConfirming = () => ({
  type: DISABLE_MERGE_CONFIRMING,
})

export const saveMergeDefaults = (params) => ({
  type: SAVE_MERGE_DEFAULTS,
  params,
})

export const openMergeDrawer = () => ({
  type: OPEN_MERGE_DRAWER,
})

export const closeMergeDrawer = () => ({
  type: CLOSE_MERGE_DRAWER,
})
